// extracted by mini-css-extract-plugin
export default {"card":"UserMessage_card__uwVHf"};